import React from "react";
import { colors } from "./colors";

/** A drop's measure around the day it started, grey up to the day it started and red from it. */
export default function Sparkline({ values, breakIndex, width = 104, height = 28 }) {
    const max = Math.max(...values);
    const min = Math.min(...values);
    const span = max - min || 1;
    const points = values.map((value, i) => [(i / (values.length - 1)) * width, height - 3 - ((value - min) / span) * (height - 6)]);
    const toPath = (pts) => pts.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
    const last = points[points.length - 1];
    const breakX = points[breakIndex]?.[0] ?? 0;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ overflow: "visible" }} aria-hidden>
            <line x1={breakX} x2={breakX} y1={0} y2={height} stroke={colors.line} strokeWidth={1} />
            <path d={toPath(points.slice(0, breakIndex + 1))} fill="none" stroke={colors.chartSubtle} strokeWidth={1.5} strokeLinejoin="round" />
            <path d={toPath(points.slice(breakIndex))} fill="none" stroke={colors.critical} strokeWidth={1.75} strokeLinejoin="round" />
            <circle cx={last[0]} cy={last[1]} r={2.25} fill={colors.critical} />
        </svg>
    );
}
